import React from 'react';
import Relay from 'react-relay';
import PropTypes from 'prop-types';
import {renderProgressBox} from '../jobs/JobView.react';
import {injectIntl, FormattedMessage} from 'react-intl';

class FlowInvocationStatus extends React.Component {
    static propTypes = {
        flowInvocation: PropTypes.object.isRequired,
        intl: PropTypes.object.isRequired,
        relay: PropTypes.object.isRequired,
    };

    constructor(props) {
        super(props);
    }

    render() {
        let { flowInvocation } = this.props;

        if (flowInvocation.cancelled) {
            return renderProgressBox({
                percent: 100,
                text: (<FormattedMessage defaultMessage="Stopped" id="jobProgress.cancelled" />),
                styles: {
                    animation: 'none',
                    background: '#ff0000'
                }
            });
        }

        if (flowInvocation.failed) {
            return renderProgressBox({
                percent: 100,
                text: (<FormattedMessage defaultMessage="Failed" id="jobProgress.failed" />),
                styles: {
                    animation: 'none',
                    background: '#ff0000'
                }
            });
        }

        if (flowInvocation.finished) {
            return renderProgressBox({
                percent: 100,
                text: (<FormattedMessage defaultMessage="Finished" id="jobProgress.finished" />),
                styles: {
                    animation: 'none',
                    background: '#228b22'
                }
            });
        }

        if (flowInvocation.tryCancel) {
            return renderProgressBox({
                percent: 0,
                text: (<FormattedMessage defaultMessage="Trying to stop" id="jobProgress.tryCancel" />),
                styles: {
                    background: '#880000'
                }
            });
        }

        if (!flowInvocation.started) {
            return renderProgressBox({
                percent: 0,
                text: (<span className="waiting"><FormattedMessage defaultMessage="Waiting" id="jobProgress.waiting" /></span>),
            });
        }

        let percent = 0;
        if (flowInvocation.maxProgress) {
            percent = Math.round((flowInvocation.currentProgress / flowInvocation.maxProgress) * 100.0);
        } else {
            percent = flowInvocation.currentProgress;
        }

        let maxValue = flowInvocation.maxProgress;

        if (maxValue) {
            return (
                <div className="progress job-progress">
                    <div aria-valuemax={maxValue} aria-valuemin="0" aria-valuenow={percent}
                            className="progress-bar progress-bar-striped active" role="progressbar"
                            style={{width: percent + "%"}}>
                    </div>
                    <span className="textValue">{percent} %</span>
                </div>
            );
        } else {
            return (
                <div className="progress job-progress">
                    <div aria-valuemax={100} aria-valuemin="0" aria-valuenow={100}
                            className="progress-bar progress-bar-striped active" role="progressbar"
                            style={{width: "100%"}}>
                    </div>
                    <span className="textValue">{percent}</span>
                </div>
            );
        }
    }
}

export default Relay.createContainer(injectIntl(FlowInvocationStatus), {
    fragments: {
        flowInvocation: () => Relay.QL`
            fragment on FlowInvocation {
                id,
                maxProgress,
                currentProgress,
                finished,
                started,
                failed,
                tryCancel,
                cancelled,
            }
        `
    }
});
